import { create } from "zustand";
import { BannerAPI } from "./../api"; // Asegúrate de que la ruta es correcta
import { postQuestionUseCase } from "./../api"; // Asegúrate de que la ruta es correcta
const api = new BannerAPI();

export const teachers3d = ["Abril", "Dario"];

export const useAITeacher3d = create((set, get) => ({
  initialize: ({ accessToken, threadId, assistantId }) => {
    set({
      accessToken,
      threadId,
      assistantId,
    });
  },
  messages: [],
  teacher: teachers3d[0],
  setTeacher: (teacher) => {
    set(() => ({
      teacher,
      messages: get().messages.map((message) => {
        message.audioPlayer = null; // New teacher, new Voice
        return message;
      }),
    }));
  },
  classroom: "default",
  setClassroom: (classroom) => {
    set(() => ({ classroom }));
  },
  loading: false,
  playAudio: false,
  setIsDisplayingText: false,
  spanish: true,
  setSpanish: (spanish) => {
    set(() => ({ spanish }));
  },
  english: true,
  setEnglish: (english) => {
    set(() => ({ english }));
  },
  speech: "Neural",
  setSpeech: (speech) => {
    set(() => ({ speech }));
  },
  askAI: async (question) => {
    if (!question) return;

    const message = { question, id: get().messages.length };
    set({ loading: true });
    const speech = get().speech;
    var accessToken = get().accessToken;
    var threadId = get().threadId;
    if (accessToken === null || accessToken === false) {
      threadId = "thread_Lws0v3Q5YWh2Ro7K8SDxPwcG";
    }
    const assistantId = get().assistantId;
    //console.log("accessToken", accessToken);
    //console.log("threadId", threadId);
    //console.log("assistantId", assistantId);
    //console.log("question", question);
    const res = await postQuestionUseCase(
      accessToken,
      threadId,
      question,
      assistantId,
    );
    if (!res) {
      set({ loading: false });
      return;
    }
    // Extraer el contenido del último mensaje donde el rol es "assistant"
    const lastAssistantMessage = res
      .reverse() // Revertir para que el primer elemento sea el último en el array original
      .find((msg) => msg.role === "assistant");

    if (lastAssistantMessage) {
      message.answer = lastAssistantMessage.content; // Guardar el contenido relevante
    }
    message.speech = speech;
    set({
      currentMessage: message,
      messages: [...get().messages, message],
      loading: false,
    });

    get().playMessage(message);
  },

  playMessage: async (message) => {
    const teacher = get().teacher; // Obtener el valor de teacher del estado
    if (!message.audioPlayer) {
      set({ loading: true });
      let formattedMessage = message.answer[0]
        .replace(/(?:\r\n|\r|\n)/g, "") // Reemplaza los saltos de línea con <br />
        .replace(/-\s+/g, "-") // Reemplaza guiones seguidos de espacios con <br /> seguido por el guión
        .replace(/(\d+\.)/g, "") // Reemplaza números seguidos de puntos con <br /> seguido por el número
        .replace(/\*/g, ""); // Elimina todos los asteriscos

      //console.log("message", formattedMessage);
      //console.log("teacher", teacher);
      const audioRes = await api.playMessage(formattedMessage, teacher);
      if (!audioRes) {
        set({ loading: false });
        return;
      }

      const audio = await audioRes.blob();
      const visemes = JSON.parse(audioRes.headers.get("visemes"));
      //console.log("visemes", visemes);
      const audioUrl = URL.createObjectURL(audio);
      const audioPlayer = new Audio(audioUrl);
      message.visemes = visemes;
      message.audioPlayer = audioPlayer;
      message.audioPlayer.onended = () => set({ currentMessage: null });
      message.audioPlayer.currentTime = 0;
      message.audioPlayer.play();

      set({
        currentMessage: message,
        loading: false,
        playAudio: true,
        messages: get().messages.map((m) =>
          m.id === message.id ? message : m,
        ),
      });
    } else {
      let formattedMessage = message.answer[0]
        .replace(/(?:\r\n|\r|\n)/g, "") // Reemplaza los saltos de línea con <br />
        .replace(/-\s+/g, "-") // Reemplaza guiones seguidos de espacios con <br /> seguido por el guión
        .replace(/(\d+\.)/g, "") // Reemplaza números seguidos de puntos con <br /> seguido por el número
        .replace(/\*/g, ""); // Elimina todos los asteriscos
      set(() => ({
        loading: true,
        playAudio: true,
      }));
      const audioRes = await api.playMessage(formattedMessage, teacher);
      const audio = await audioRes.blob();
      const visemes = JSON.parse(await audioRes.headers.get("visemes"));
      const audioUrl = URL.createObjectURL(audio);
      const audioPlayer = new Audio(audioUrl);
      message.visemes = visemes;
      message.audioPlayer = audioPlayer;
      message.audioPlayer.onended = () => set({ currentMessage: null });
      message.audioPlayer.currentTime = 0;
      message.audioPlayer.play();
      set({
        currentMessage: message,
        loading: false,
        playAudio: true,
        messages: get().messages.map((m) =>
          m.id === message.id ? message : m,
        ),
      });
    }
  },
  stopMessage: (message) => {
    message.audioPlayer.pause();
    set(() => ({
      playAudio: false,
      currentMessage: null,
    }));
  },
  EndTextMessage: (newDisplayState) => {
    set(() => ({
      setIsDisplayingText: newDisplayState,
    }));
  },
}));
